var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluetoothslash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2.316 0.522 25.771 32.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "sf-bluetooth-slash-cut0",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.367 32.182C25.691 33.487 27.837 33.487 29.119 32.143C30.394 30.846 30.408 28.758 29.1 27.45L6.037 4.407C4.732 3.102 2.59 3.102 1.285 4.407C0 5.692 0 7.854 1.285 9.139Z",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sf-bluetooth-slash-cut0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.968 31.426C11.968 33.012 14.015 33.492 15.182 32.478L22.908 25.913C23.615 25.323 23.886 24.618 23.886 23.93C23.886 23.225 23.579 22.504 22.873 21.966L16.266 16.786L22.889 11.589C23.579 11.068 23.883 10.331 23.886 9.642C23.89 8.954 23.615 8.249 22.908 7.643L15.182 1.078C13.871 0 11.968 0.56 11.968 2.146L11.968 13.3L6.902 9.239C6.544 8.939 6.139 8.78 5.724 8.78C4.869 8.78 4.236 9.425 4.236 10.236C4.236 10.733 4.413 11.182 4.826 11.497L11.577 16.773L4.826 22.059C4.413 22.387 4.236 22.839 4.236 23.336C4.236 24.148 4.876 24.792 5.724 24.792C6.132 24.792 6.54 24.62 6.902 24.332L11.968 20.256ZM15.048 28.355L15.048 19.835L20.472 23.983ZM15.048 13.737L15.048 5.201L20.472 9.589Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.787 30.779C26.318 31.309 27.184 31.309 27.696 30.779C28.207 30.248 28.227 29.385 27.696 28.87L4.633 5.811C4.102 5.28 3.236 5.28 2.705 5.811C2.178 6.322 2.194 7.208 2.705 7.72Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetoothslash);
export default __webpack_public_path__ + "static/media/bluetooth.slash.dce4eacf1d29a5698c933f00d290545f.svg";
export { ForwardRef as ReactComponent };